import { Link } from 'react-router-dom'
import { ASSETS } from '@/constants/assets'
import Layout from '@/components/layout/Layout'
import ImageCard from '@/components/ui/image-card'

const MorphingEffect = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Creating the Morphing Effect of the Luma Dream Machine Website
        </h1>
        <p className="text-foreground text-[1.375rem] leading-[1.3] [text-wrap:balance]">
          Learn how to create this powerful morphing effect with only JavaScript using the Canvas2D API.
        </p>
        <div className="subline text-muted-foreground text-[0.875rem] leading-[1.2]">
          By{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Jean Mazouni
          </Link>{' '}
          in{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Tutorials
          </Link>{' '}
          on December 9, 2024
        </div>
        <ImageCard 
          src="https://raw.githubusercontent.com/guilanier/codrops-sdf-lensblur/refs/heads/master/docs/demo.gif" 
          alt="Morphing Effect Demo"
        />
        <div className="blog-body space-y-4 text-foreground text-[1.125rem] leading-[1.625] [text-wrap:balance]">
          <p>
            Ever since discovering them through <Link to="https://tympanus.net/Tutorials/SDFLensBlur/" className="underline">The Book of Shaders</Link>, I have been captivated by the power of Signed Distance Functions (SDFs). These functions are highly efficient for rendering complex geometries and shapes, and for creating dynamic visual effects. They simplify necessary calculations for edge detection and shape manipulation, making them ideal for advanced graphic applications.
          </p>
          <p>
            Although I will do my best to explain it further through application, I highly recommend checking out shapes part of <Link to="https://tympanus.net/Tutorials/SDFLensBlur/" className="underline">The Book of Shaders</Link> and the excellent resources from Inigo Quilez to learn more about SDFs.
          </p>
          <p>
            In this tutorial, we will learn how to leverage the power of SDFs by drawing a simple shape (a rounded rectangle) and explore how we can manipulate the properties and parameters of SDF functions to create a "Lens Blur" effect on interaction. This requires some knowledge of Three.js or any WebGL framework, as well as familiarity with GLSL shading language for writing shaders.
          </p>
        </div>
        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Visual Examples
          </h2>
          <div className="grid grid-cols-2 gap-4 w-full">
            <ImageCard 
              src={ASSETS.images.morphingDemo}
              alt="Morphing Effect Demo 1"
            />
            <ImageCard 
              src={ASSETS.images.morphingDemo}
              alt="Morphing Effect Demo 2"
            />
          </div>
        </div>
        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Square Examples
          </h2>
          <div className="grid grid-cols-2 gap-4 w-full">
            <ImageCard 
              src={ASSETS.images.morphingDemo}
              alt="Morphing Effect Demo 1"
              isSquare
            />
            <ImageCard 
              src={ASSETS.images.morphingDemo}
              alt="Morphing Effect Demo 2"
              isSquare
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default MorphingEffect 